import React, { useEffect, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/api";
import { useLang } from "@/i18n";

export default function PaymentSuccess() {
  const { lang } = useLang();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking"); // checking | paid | failed
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) return setStatus("failed");
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          const acc = await api.get(`/payments/access/${sessionId}`);
          localStorage.setItem("guardia_bp_token", acc.data.access_token);
          setStatus("paid");
          return;
        }
      } catch (e) {}
      if (tries < 15) setTimeout(poll, 2000);
      else setStatus("failed");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0c0d10] px-6 text-center">
      <div className="max-w-md">
        {status === "checking" && (
          <>
            <Loader2 size={48} className="animate-spin text-[#E63946] mx-auto" />
            <p className="mt-4 text-zinc-400">{lang === "it" ? "Verifica del pagamento…" : "Verifying payment…"}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} className="text-[#10B981] mx-auto" />
            <h1 className="mt-4 font-heading text-3xl font-black uppercase text-white">
              {lang === "it" ? "Accesso sbloccato!" : "Access unlocked!"}
            </h1>
            <p className="mt-2 text-zinc-400">
              {lang === "it"
                ? "Il tuo Striker Blueprint è pronto. Ti abbiamo inviato anche un'email di conferma."
                : "Your Striker Blueprint is ready. We also sent you a confirmation email."}
            </p>
            <button
              onClick={() => navigate("/blueprint/console")}
              data-testid="go-to-console-btn"
              className="mt-6 px-8 py-3 bg-[#E63946] hover:bg-[#D90429] text-white font-bold uppercase rounded-md"
            >
              {lang === "it" ? "Apri la Console" : "Open the Console"}
            </button>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle size={56} className="text-[#EF4444] mx-auto" />
            <p className="mt-4 text-zinc-400">
              {lang === "it" ? "Non riusciamo a confermare il pagamento." : "We couldn't confirm the payment."}
            </p>
            <Link to="/blueprint" className="mt-4 inline-block text-[#E63946] font-bold uppercase">
              {lang === "it" ? "Riprova" : "Try again"}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
